import React from 'react';
import { NavLink } from 'react-router-dom';

const AddDocumentCrumb = () => <NavLink to="/admin/documents/add">Add Document</NavLink>;

export default AddDocumentCrumb;
